import { AdditionalFilter, WidgetFilter } from '@ddv/models';

export function getFilters(filters: AdditionalFilter[]): WidgetFilter[] {
    return filters.map((f) => ({
        name: f.name,
        displayName: f.displayName,
        criteria: f.criteria ?? 'INCLUDE',
        filterValuesType: f.filterValuesType ?? 'string',
        values: f.values ?? [],
    }));
}
